module.exports = __webpack_public_path__ + "static/partner-logo-aktors-3edd306912119af9b8f0eab242804135.png";